import { useEffect, useRef } from 'react';
export function useEventListener(eventName, callback, element = window) {
    const savedCallback = useRef(undefined);
    const savedElement = useRef(element);
    const savedEventListener = useRef((event) => savedCallback.current(event));
    const removeListener = () => {
        savedElement.current.removeEventListener(eventName, savedEventListener.current);
    };
    const addListener = () => {
        savedElement.current.addEventListener(eventName, savedEventListener.current);
    };
    useEffect(() => {
        removeListener();
        savedElement.current = element;
        savedCallback.current = callback;
        addListener();
    }, [element, callback]);
    useEffect(() => {
        return () => {
            removeListener();
        };
    }, []);
}
//# sourceMappingURL=useEventListener.js.map